/**
 * ErrorPage
 *
 * We show this page when an uncaught exception occurs
 *
 */

import React from 'react';

import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';

import ZeroStateView from 'components/ZeroStateView';

const ErrorPage = () => {
  return (
    <Container
      maxWidth={false}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingY: 3,
        height: '100vh',
      }}
    >
      <Paper
        sx={{
          padding: 4,
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <ZeroStateView
          size='large'
          id='error-page'
          animate
          title="Uh Oh. Something isn't quite right here."
          description="Our mistake! Rest assured, we're working to resolve the problem as soon as possible. We apologize for the inconvenience."
          qIllustration='planeCrash'
          report='report js crash'
          button={
            <Button
              variant='contained'
              color='primary'
              onClick={() => {
                window.location.href = '/';
              }}
            >
              Return to Dashboard
            </Button>
          }
        />
      </Paper>
    </Container>
  );
};

export default ErrorPage;
